'use strict';

import { Modal } from 'bootstrap';

export default class OPLMyProfile {
    constructor() {
        this.profileFormWrapper = null;
        this.profileForm = null;
        this.pinChangeFormWrapper = null;
        this.pinChangeForm = null;
        this.cardExpiryForm = null;
        this.responseModal = null;
        this.responseModalHeader = null;
        this.responseModalMessage = null;
        this.phoneNumberInput = null;
        this.phoneValueLength = 0;
        this.phoneOutput = '';
        this.expirationAlert = null;
        this.myOPLAlertIcon = null;
        this.myOPLTrigger = null;
    }

    init() {
        this.responseModal = document.querySelector('#my-profile-modal');
        this.responseModalHeader = document.querySelector('#my-profile-modal-header');
        this.responseModalMessage = document.querySelector('#my-profile-modal-message');
        this.expirationAlert = document.getElementById('my-profile-expiration-alert');
        this.myOPLAlertIcon = document.getElementById('myopl-alert-icon');
        this.myOPLTrigger = document.getElementById('myopl-trigger');

        this.initProfileForm();
        this.initPinChangeForm();
        this.initCardExpiryForm();
    }

    initProfileForm() {
        const self = this;

        self.profileFormWrapper = document.querySelector('#my-profile-form-wrapper');
        self.profileForm = document.querySelector('#my-profile-form');

        if (self.profileForm) {
            self.profileForm.addEventListener('submit', (e) => {
                self.handleFormSubmit(e, '/api/my-profile/update-profile', self.profileForm, new FormData(self.profileForm), self.profileFormWrapper, self.initProfileForm.bind(self));
            });
        }

        self.phoneNumberInput = document.querySelector('#TelephoneNumber');
        self.phoneValueLength = 0;
        self.phoneOutput = '';

        if (self.phoneNumberInput) {
            self.autoformatPhoneNumber();
            self.phoneNumberInput.addEventListener('blur', () => {
                self.autoformatPhoneNumber();
            });
            self.phoneNumberInput.addEventListener('input', () => {
                self.autoformatPhoneNumber();
            });
        }
    }

    initPinChangeForm() {
        const self = this;

        self.pinChangeFormWrapper = document.querySelector('#pin-change-form-wrapper');
        self.pinChangeForm = document.querySelector('#pin-change-form');

        if (self.pinChangeForm) {
            self.pinChangeForm.addEventListener('submit', (e) => {
                self.handleFormSubmit(e, '/api/my-profile/change-pin', self.pinChangeForm, new FormData(self.pinChangeForm), self.pinChangeFormWrapper, self.initPinChangeForm.bind(self));
            });
        }
    }

    initCardExpiryForm() {
        const self = this;

        self.cardExpiryFormWrapper = document.querySelector('#card-expiry-form-wrapper');
        self.cardExpiryForm = document.querySelector('#card-expiry-form');

        if (self.cardExpiryForm) {
            self.cardExpiryForm.addEventListener('submit', (e) => {
                self.handleFormSubmit(e, '/api/my-profile/renew-card', self.cardExpiryForm, new FormData(self.cardExpiryForm), self.cardExpiryFormWrapper, self.initCardExpiryForm.bind(self), true);
            });
        }
    }

    handleFormSubmit(e, url, formElement, formData = null, wrapperToUpdate = null, callback = null, isExpiryCardForm = false) {
        e.preventDefault();

        const config = {
            method: 'POST'
        };

        if (formData) {
            config['body'] = formData;
        }

        const loader = formElement.querySelector('.opl-loader');
        if (loader) loader.style.display = 'block';

        fetch(url, config)
            .then(response => {
                return response.json();
            })
            .then(result => {
                if (result.object && result.partialAsString) {
                    this.showModal(result.object.header, result.object.message);
                    if (wrapperToUpdate) {
                        wrapperToUpdate.innerHTML = result.partialAsString;
                        if (callback) {
                            callback();
                        }
                    }

                    // Additional logic on expiry card form submission
                    if (isExpiryCardForm) {
                        this.enableForm(this.profileFormWrapper);
                        this.enableForm(this.pinChangeFormWrapper);

                        if (this.expirationAlert) {
                            this.expirationAlert.style.display = 'none';
                        }

                        if (this.myOPLAlertIcon) {
                            this.myOPLAlertIcon.classList.remove('has-expiry-alert');
                        }

                        if (this.myOPLTrigger) {
                            this.myOPLTrigger.classList.remove('has-expiry-alert');
                        }
                    }
                }
            })
            .catch(error => {
                console.error("Error submitting form:", error);
            })
            .finally(() => {
                if (loader) loader.style.display = 'none';
            });
    }

    showModal(header, message) {
        const modal = Modal.getOrCreateInstance(this.responseModal);
        this.responseModalHeader.innerHTML = header;
        this.responseModalMessage.innerHTML = message;
        modal.show();
    }

    autoformatPhoneNumber() {
        let shouldHaveOne = this.phoneNumberInput.pattern.startsWith("^1");

        if (shouldHaveOne && this.phoneNumberInput.value.indexOf("1(") != 0) {
            this.phoneNumberInput.value = "1(";
        }

        let phoneNumbers = this.phoneNumberInput.value.replace(/[^0-9]/g, '');

        let area = shouldHaveOne ? phoneNumbers.substr(1, 3) : phoneNumbers.substr(0, 3);
        let tel1 = shouldHaveOne ? phoneNumbers.substr(4, 3) : phoneNumbers.substr(3, 3);
        let tel2 = shouldHaveOne ? phoneNumbers.substr(7, 4) : phoneNumbers.substr(6, 4);

        if (area.length < 3) {
            this.phoneOutput = shouldHaveOne ? `1(${area}` : `(${area}`;
        } else if (area.length === 3 && tel1.length < 3) {
            this.phoneOutput = shouldHaveOne ? `1(${area}) ${tel1}` : `(${area}) ${tel1}`;
        } else if (area.length === 3 && tel1.length === 3) {
            this.phoneOutput = shouldHaveOne ? `1(${area}) ${tel1}-${tel2}` : `(${area}) ${tel1}-${tel2}`;
        }

        /**
        * if deleting characters do not format field
        */
        if (this.phoneNumberInput.value.length >= this.phoneValueLength) {
            this.phoneNumberInput.value = this.phoneOutput;
            this.phoneValueLength = this.phoneOutput.length;
        } else {
            this.phoneValueLength = this.phoneNumberInput.value.length;
        }
    }

    enableForm(wrapper) {
        wrapper.querySelectorAll('[disabled]').forEach(el => {
            el.disabled = false;
        });
    }
}
